import service from '@/store/services/settings/activity-tariffs-service';

const state = {
    list: {},
    activityTariff: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, activityTariff) => {
        state.activityTariff = activityTariff;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },


    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(activityTariff => {
                commit('SET_RESOURCE', activityTariff);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(activityTariff => {
                commit('SET_RESOURCE', activityTariff);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((activityTariff) => {
                commit('SET_RESOURCE', activityTariff);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((activityTariff) => {
                commit('SET_RESOURCE', activityTariff);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    activityTariff: state => state.activityTariff,
    dropdown: (state) => {
        return state.list.map(activityTariff => ({
            id: activityTariff.id,
            amount: activityTariff.amount,
            activity_name: activityTariff.activity_name,
            tariff_name: activityTariff.tariff_name,
        }));
    }
};

const activityTariffs = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default activityTariffs;
